<script>
import appConfig from '@src/app.config.json'
import Axios from '@plugin/axios.js'
import Layout from '@layouts/main.vue'
import Hero from '@components/ui/hero-jumbotron.vue'
import Card from '@components/ui/cards/_base-card.vue'
import Pagination from '@components/ui/basic-pagination.vue'

export default {
  page() {
    return {
      title: this.showModal ? this.pageTitle : this.pageParentTitle,
      meta: this.showModal ? this.pageMeta : this.pageParentMeta,
    }
  },
  components: {
    Layout,
    Hero,
    Card,
    Pagination,
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      const penghubung =
        'and,for,with,of,dan,serta,atau,tetapi,melainkan,padahal,sedangkan,yang,agar,supaya,biar,jika,kalau,jikalau,asalkan,bila,manakala,sejak,semenjak,sedari,sewaktu,tatkala,ketika,sementara,begitu,seraya,selagi,selama,serta,sambil,demi,setelah,sesudah,sebelumsehabis,selesai,seusai,hingga,sampai,andaikan,seandainya,umpamanya,sekiranya,biarpun,walaupun,sekalipun,sungguhpun,kendatipun,seakan-akan,seolah-olah,sebagaimana,seperti,sebagai,laksana,ibarat,daripada,alih-alih,karena,sampainya,makanya,dengan,tanpa,bahwa,as,ke'
      const str = value
        .trim()
        .replace(/ {1,}/g, ' ')
        .toLowerCase()
        .split(' ')
        .map((word) => {
          if (penghubung.split(',').includes(word)) {
            return word[0].toLowerCase() + word.slice(1)
          } else if (word[0] === '(') {
            return '(' + word.charAt(1).toUpperCase() + word.substring(2)
          }
          return word[0].toUpperCase() + word.slice(1)
        })
        .join(' ')
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    excerpt: function(text, limit) {
      return text
        .split(/\s+/)
        .slice(0, limit)
        .join(' ')
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
    download: function(ID) {
      return appConfig.download_handler + ID
    },
  },
  data() {
    return {
      Infographics: [],
      modalData: [],
      page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      limit: 9,
      totalData: 0,
      totalPages: 0,
      activeOrder: 'Latest',
      showModal: false,
      currentUrl: window.location.origin + window.location.pathname,
      /** skeleton and loading state */
      loadOpacity: false,
      isLoading: true,
      isModalLoading: false,
      pageName: 'default',
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      firstLoad: false,
      /** for SEO, meta and hero */
      pageTitle: 'Loading...',
      featuredImage: '',
      pageDescription: '',
      pageMeta: [],
      pageParentTitle: 'Loading...',
      pageParentDescription: '',
      pageParentMeta: [],
      origin: window.location.origin,
    }
  },
  watch: {
    showModal() {
      if (this.showModal === false) {
        this.addHashToLocation('/infographic')
      }
    },
    page: function() {
      this.loadOpacity = true
      if (this.page >= 1) {
        return new Promise((resolve, reject) => {
          resolve(this.getInfographics())
        })
      }
    },
  },
  async mounted() {
    await this.getInfographics()
    if (this.$route.params.popup) {
      // this.$bvModal.show('infographicPopup')
      this.openPopup(this.$route.params.popup)
    }
    if (this.$route.query.lang) {
      this.$router.push({
        path: '/infographic',
      })
    }
  },
  // destroyed() {
  //   if (this.$router.currentRoute.name === 'infographic') {
  //     this.$router.push({
  //       path: '/infographic',
  //     })
  //   }
  // },
  methods: {
    getInfographics: function(param = {}) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'infographics',
        simple: true,
        page: this.page,
        limit: this.limit,
        order: 'DESC',
        order_by: 'created_at',
        lang: this.lang,
        taxonomy_show: false,
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      // get the news
      Axios.get(endpoint).then((response) => {
        const data = response.data.data
        // after successfull response, we should then update the menuItems on data() above
        if (response.data) {
          this.Infographics = data
          this.totalData = response.data.data_total
          this.totalPages = response.data.page_total
          this.isLoading = false
          this.loadOpacity = false
        }
        this.firtLoad = true
        /** FOR SEO and META tag */
        let keyInfo
        if (response.data.info[this.lang] !== undefined) {
          keyInfo = response.data.info[this.lang]
        } else {
          keyInfo = response.data.info[this.lang + ' ']
        }
        this.pageParentTitle = keyInfo[0].trim()
        this.pageParentDescription = keyInfo[1].trim()
        this.pageParentMeta = [
          {
            name: 'description',
            content: keyInfo[1].trim(),
          },
          // facebook
          {
            property: 'og:type',
            content: 'article',
          },
          {
            property: 'og:title',
            content: keyInfo[0].trim(),
          },
          {
            property: 'og:description',
            content: keyInfo[1].trim(),
          },
          {
            property: 'og:url',
            content: this.currentUrl,
          },
          {
            property: 'og:site_name',
            content: appConfig.title,
          },
          // twitter
          {
            name: 'twitter:title',
            content: keyInfo[0].trim(),
          },
          {
            name: 'twitter:description',
            content: keyInfo[1].trim(),
          },
          {
            name: 'twitter:site',
            content: this.currentUrl,
          },
        ]
      })
    },
    openPopup: function(slug) {
      this.isModalLoading = true
      this.showModal = true
      this.modalData = []
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'infographics',
        simple: true,
        record_slug: slug,
        lang: this.lang,
        taxonomy_show: false,
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      // get the news
      Axios.get(endpoint).then((response) => {
        const data = response.data.data[0]
        // after successfull response, we should then update the menuItems on data() above
        if (data) {
          this.modalData = data
          // console.log(data)
          this.isModalLoading = false
          this.addHashToLocation('/infographic/' + slug)
        } else {
          this.showModal = false
          this.modalData = []
          this.addHashToLocation('/infographic')
        }
        if (data.atribut.featured_image.data[0]) {
          this.featuredImage =
            appConfig.s3_endpoint + data.atribut.featured_image.data[0].content
        }
        /** FOR SEO AND META TAG PURPOSE */
        this.pageTitle = data.title

        this.pageMeta = [
          {
            name: 'description',
            content: this.$options.filters
              .plainText(data.content)
              .slice(0, 160),
          },
          // facebook
          {
            property: 'og:type',
            content: 'article',
          },
          {
            property: 'og:title',
            content: data.title,
          },
          {
            property: 'og:description',
            content: this.$options.filters
              .plainText(data.content)
              .slice(0, 160),
          },
          {
            property: 'og:image',
            content: this.featuredImage,
          },
          {
            property: 'og:url',
            content: this.currentUrl,
          },
          {
            property: 'og:site_name',
            content: appConfig.title,
          },
          // twitter
          {
            name: 'twitter:title',
            content: data.title,
          },
          {
            name: 'twitter:image',
            content: this.featuredImage,
          },
          {
            name: 'twitter:description',
            content: this.$options.filters
              .plainText(data.content)
              .slice(0, 160),
          },
          {
            name: 'twitter:site',
            content: this.currentUrl,
          },
        ]
      })
    },
    /**
     * Ordering Function
     */
    order: function(order, orderBy, active = '') {
      // this.News = this.News
      this.activeOrder = active
      this.getInfographics({
        order: order,
        order_by: orderBy,
      })
    },
    addHashToLocation(params) {
      history.pushState({}, null, params)
      this.currentUrl = window.location.origin + params
    },
    s3: function(path) {
      return appConfig.s3_endpoint + path
    },
    /**
     * Handler paginate
     */
    pageHandler: function(to) {
      this.page = to
      this.scrollToTargetAdjusted('infographic-handler')
    },
    /**
     * Check if array is empty
     */
    checkArrayEmpty: function(array) {
      if (!Array.isArray(array) || !array.length) {
        return false
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <Layout>
    <Hero
      height="25rem"
      :background="require('@assets/images/demo/academic-journal/banner.jpg')"
    >
      <b-container class="h-100">
        <b-row class="justify-content-center h-100">
          <div class="col-lg-12 text-center align-self-center">
            <h1
              class="text-white"
              :style="{ fontSize: '2.75rem', fontWeight: '700' }"
              >{{ pageParentTitle }}</h1
            >
            <p
              class="mt-3 mb-4"
              :style="{
                color: '#fff',
                fontSize: '1.2rem',
                fontWeight: '300',
              }"
              >{{ pageParentDescription }}</p
            >
          </div>
        </b-row>
      </b-container>
    </Hero>

    <b-container id="infographic-handler" class="my-5">
      <!-- filters -->
      <b-row class="justify-content-end">
        <b-col cols="lg-5 d-flex justify-content-end">
          <div class="mb-3">
            <span class="mr-3" :style="{ color: 'gray' }">
              {{ $t('Sort by') }}
            </span>
            <b-dropdown
              :text="$t(activeOrder)"
              variant="light"
              class="mx-0"
              :class="$style.infographiFilter"
            >
              <b-dropdown-item
                @click="order('desc', 'created_at', $t('Latest'))"
              >
                {{ $t('Latest') }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="order('asc', 'created_at', $t('Oldest'))"
              >
                {{ $t('Oldest') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </b-col>
      </b-row>
      <!-- contents -->
      <div
        v-show="isLoading && firstLoad === false"
        class="position-relative"
        style="min-height: 7rem"
      >
        <img
          src="@assets/icons/loading.gif"
          alt="loading"
          class="loadingIcon"
        />
      </div>
      <b-row v-if="Infographics && !isLoading">
        <b-col
          v-for="(infographic, index) in Infographics"
          :key="index"
          cols="lg-4"
          class="d-flex align-items-strecth my-4"
        >
          <Card
            v-if="infographic.atribut"
            content-no-border="true"
            radius="10px"
            img-height="30rem"
            img-object-fit="contain"
            border-color="rgba(0,0,0,.25)"
            :img-src="
              infographic.atribut.featured_image
                ? s3(infographic.atribut.featured_image.data[0].content)
                : ''
            "
            pointer
            :class="[loadOpacity ? 'isLoading' : '']"
            @click.native="openPopup(infographic.slug)"
          >
            <h3 :style="{ color: '#2980B9', margin: '1rem 0' }">{{
              infographic.title | capitalize
            }}</h3>
            <p>{{ infographic.content | plainText | excerpt(10) }}</p>
            <span class="date" :style="{ color: 'gray' }">
              <i>{{ infographic.created_at_format }}</i>
            </span>
          </Card>
        </b-col>
      </b-row>
      <b-row v-if="totalData > 9" class="mt-4 mb-5 justify-content-center">
        <b-col cols="lg-9">
          <Pagination
            :total-pages="totalPages"
            :selected-page="page"
            @clicked="pageHandler"
          ></Pagination>
        </b-col>
      </b-row>
    </b-container>

    <!-- Infographic POPUP -->
    <b-modal
      id="infographicPopup"
      v-model="showModal"
      size="lg"
      :centered="true"
      :hide-header="true"
      :hide-footer="true"
    >
      <b-container>
        <img
          v-show="isModalLoading"
          src="@assets/icons/loading.gif"
          alt="loading"
          class="loadingIcon"
          style="z-index: 1"
        />

        <b-row v-show="isModalLoading === false" class="justify-content-center">
          <!-- close button -->
          <div class="closeIcon" @click="$bvModal.hide('infographicPopup')">
            <img src="@assets/icons/close.png" alt="x" />
          </div>
          <b-col v-if="modalData.atribut" cols="lg-12" class="infographic">
            <div class="infographicHeader">
              <h2>{{ modalData.title | capitalize }}</h2>
              <span class="date" :style="{ color: 'gray' }">
                <i>{{ modalData.created_at_format }}</i>
              </span>
            </div>
            <div class="infographicFooter my-3">
              <div v-if="modalData.atribut">
                <a
                  v-for="(download, index) in modalData.atribut.link_download
                    .data"
                  :key="index"
                  :href="download.ID | download"
                  class="bg-primary text-white px-3 py-2 d-flex justify-content-center mr-0 mr-lg-4"
                  target="_blank"
                >
                  <img
                    src="@assets/icons/Icon_Download.png"
                    alt=""
                    :style="{ filter: 'brightness(5)', marginRight: '.5rem' }"
                    width="14"
                  />
                  {{ $t('Download') }}
                </a>
                <small
                  v-if="modalData.atribut.download_counts.data.length !== 0"
                  >{{ $t('Downloads') }}:
                  {{ modalData.atribut.download_counts.data[0].content }}
                </small>
              </div>
              <div class="social-wrapper">
                {{ $t('Share') }} :
                <ShareNetwork
                  network="facebook"
                  :url="currentUrl"
                  :title="modalData.title"
                  :description="modalData.content | plainText | excerpt(25)"
                  hashtags="lexikan"
                >
                  <img src="@assets/icons/Icon_FB.png" alt="" class="social" />
                </ShareNetwork>
                <ShareNetwork
                  network="twitter"
                  :url="
                    `${origin}/sharer.php?page=infographic&slug=${modalData.slug}`
                  "
                  :title="modalData.title"
                  hashtags="lexikan"
                >
                  <img
                    src="@assets/icons/Icon_Twitter.png"
                    alt=""
                    class="social"
                  />
                </ShareNetwork>
                <ShareNetwork
                  network="linkedin"
                  :title="modalData.title"
                  :url="currentUrl"
                >
                  <img
                    src="@assets/icons/Icon_Linkedin.png"
                    alt=""
                    class="social"
                    @click="shareArticle('linkedin')"
                  />
                </ShareNetwork>
              </div>
            </div>
          </b-col>
          <b-col v-if="modalData.atribut" cols="lg-12">
            <div>
              <img
                v-for="(img, index) in modalData.atribut.featured_image.data"
                :key="index"
                v-lazy="s3(img.content)"
                alt=""
                class="img-fluid"
              />
            </div>
          </b-col>
          <b-col v-if="modalData.content" cols="lg-12">
            <div v-html-safe="modalData.content" class="infographicBody"> </div>
            <a
              v-for="(download, index) in modalData.atribut.link_download.data"
              :key="index"
              :href="download.ID | download"
              class="bg-primary text-white px-3 py-2 d-flex justify-content-center mr-0 mr-lg-4 mt-3"
              target="_blank"
            >
              <img
                src="@assets/icons/Icon_Download.png"
                alt=""
                :style="{ filter: 'brightness(5)', marginRight: '.5rem' }"
                width="14"
              />
              {{ $t('Download') }}
            </a>
            <small v-if="modalData.atribut.download_counts.data.length !== 0"
              >{{ $t('Downloads') }}:
              {{ modalData.atribut.download_counts.data[0].content }}
            </small>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.infographiFilter {
  ul[role='menu'] {
    &:focus {
      outline: none;
    }
  }
  button {
    background-color: $white;
    border: 1px solid $gray;
    border-radius: 0;
  }
}
[role='button'] {
  &:focus {
    outline: none;
  }
}
</style>

<style lang="scss">
@import '@design';
[class='modal-backdrop'] {
  background-color: rgba(0, 0, 0, 0.2);
}
#infographicPopup {
  [class='modal-header'] {
    border-bottom: none;
  }
  [class='modal-body'] {
    min-height: 65vh;
    padding: 3rem;
  }
  [class='modal-content'] {
    border: none;
    border-radius: $radius;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
  }
  .closeIcon {
    img {
      position: absolute;
      top: 2.5rem;
      right: 2.5rem;
      z-index: 1;
      width: 24px;
      cursor: pointer;
    }
  }
  .infographic {
    font-family: $content-font-family;
    .infographicHeader {
      h2 {
        color: $primary;
      }
    }
    .infographicBody {
      margin: 2rem 0;
      color: gray;
    }
    .infographicFooter {
      display: flex;
      .social {
        width: 40px;
        margin-right: 0.5rem;
        cursor: pointer;
        &:first-child {
          margin-left: 0.75rem;
        }
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  #infographicPopup {
    padding: 0;
    [class~='modal-dialog'] {
      margin: 0;
    }
    [class~='modal-content'] {
      border-radius: 0;
    }
    [class='modal-body'] {
      padding: 1rem;
    }
    .closeIcon {
      img {
        position: fixed;
        top: 1rem;
        right: 1rem;
        width: 32px;
        padding: 0.5rem;
        background-color: #fff;
        border: 1px solid black;
        border-radius: 50%;
      }
    }
    .infographic {
      .infographicHeader {
        margin: 1rem 0;
      }
      .infographicFooter {
        flex-wrap: wrap;
        button {
          width: 100%;
        }
        [class~='social-wrapper'] {
          margin: 1rem 0;
        }
      }
    }
  }
}
</style>
